<template>
  <section class="product-new-box">
    <div class="product-new">
      <ElRow>
        <ElCol class="shop" :span="24">
          <div style="width: 100px;float: left;">
            <span class="must-check">* </span>项目分类：
          </div>
          <ElRadioGroup v-model="shop_type" class="shop-type">
            <ElRadioButton
              v-for="item in classification"
              :key="item.id"
              :label="item.id"
              >{{ item.type_name }}</ElRadioButton
            >
          </ElRadioGroup>
        </ElCol>
      </ElRow>
      <ElRow>
        <ElCol :span="10"
          ><span class="must-check">* </span>项目名称：
          <ElInput
            v-model="commodity_name"
            class="product-name"
            placeholder="请输入内容"
          ></ElInput>
        </ElCol>
        <ElCol :span="7"
          ><span class="must-check">* </span>
          项目价格：
          <ElInput
            v-model="price"
            class="product-price"
            placeholder=""
          ></ElInput>
          元
        </ElCol>
        <ElCol class="pics" :span="7"
          ><span class="must-check">* </span>单位：
          <ElSelect
            v-model="company"
            class="product-pics"
            placeholder="请选择"
            allow-create
            filterable
          >
            <ElOption
              v-for="item in pics"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </ElOption> </ElSelect
        ></ElCol>
      </ElRow>
      <PhotoAdd
        :imgtitle="imgtitle"
        @photoImgUrl="photoImgUrl"
        @imgLoading="imgLoading"
      />
    </div>
    <ElRow>
      <ElCol class="product-submit" :span="24">
        <ElButton round @click="addProgress">提交</ElButton>
      </ElCol>
    </ElRow>
  </section>
</template>

<script>
import Cookie from 'js-cookie';
import {http, catchAppError} from '@/util';
import url from '@/config';
import {menusNavigation} from '@/store';
import toast from '@/toast';
import PhotoAdd from './PhotoAdd.vue';

export default {
  name: 'ProductNew',
  components: {
    PhotoAdd
  },
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      addCureType: 4,
      loading: true,
      imgUpLoading: false,
      url,
      headers: {
        token: Cookie.get('token')
      },
      imgUrl: '',
      imgtitle: '项目图片',
      fileList: [],
      parentParams: {parent: 0},
      category: '',
      classification: [],
      commodity_name: '',
      shop_type: '',
      company: '',
      price: '',
      pics: [
        {label: '次', value: '次'},
        {label: '盒', value: '盒'},
        {label: '听', value: '听'},
        {label: '个', value: '个'},
        {label: '袋', value: '袋'},
        {label: '包', value: '包'},
        {label: '瓶', value: '瓶'}
      ],
      thumbnail: ''
    };
  },
  computed: {
    options() {
      // eslint-disable-next-line camelcase
      return this.categoryList.map(({id, type_name}) => ({
        label: type_name,
        value: id
      }));
    }
  },
  watch: {
    category() {
      this.parentParams.parent = this.category;
      http
        .post(url.type, this.parentParams)
        .then(res => {
          this.classification = res;
          if (this.params.id && this.params.nav === '1') {
            http
              .post(url.getProduct, {commodity_id: this.params.id})
              .then(res => {
                this.commodity_name = res.commodity_name;
                this.company = res.company;
                this.price = res.price;
                // eslint-disable-next-line prefer-destructuring
                this.shop_type = res.shop_type[0];
                this.thumbnail = res.thumbnail.value;
                this.imgUrl = res.thumbnail.photo;
              })
              .catch(catchAppError);
          }
        })
        .catch(catchAppError);
    }
  },
  beforeMount() {
    this.getType();
  },
  methods: {
    photoImgUrl(url) {
      this.thumbnail = url;
    },
    imgLoading(i) {
      this.imgUpLoading = i;
    },
    getType() {
      this.category = 13;
    },
    addProgress() {
      if (this.imgUpLoading) {
        toast('图片正在上传，稍后提交');
        return;
      }
      const allIsCheck =
        this.commodity_name && this.company && this.price && this.shop_type;
      if (!allIsCheck) {
        toast('必填项不能为空');
        return;
      }
      const addParams = {
        commodity_name: this.commodity_name,
        company: this.company,
        price: this.price,
        shop_type: [this.shop_type],
        thumbnail: this.thumbnail,
        type: this.addCureType
      };
      if (this.params.id) {
        addParams.commodity_id = this.params.id;
      }
      const upUrl = this.params.id ? url.upProgress : url.addProgress;
      http
        .post(upUrl, addParams)
        .then(() => {
          this.resetData();
          menusNavigation.navTab('ProjectManage', '4');
        })
        .catch(catchAppError);
    },
    resetData() {
      this.commodity_name = '';
      this.company = '';
      this.price = '';
      this.shop_type = [];
      this.thumbnail = '';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.product-new-box {
  padding-bottom: 10px;
  color: #333;
  .product-submit {
    margin-top: 55px;
    text-align: center;
    .el-button {
      width: 230px;
      padding: 14px 0;
      background-color: #ffb03e;
      border-color: #ffb03e;
      color: #fff;
    }
  }
  .product-new {
    width: 950px;
    font-size: 16px;
    .shop {
      min-height: 23px;
    }
    .shop-type {
      width: 770px;
      float: left;
      display: inline-block;
      vertical-align: top;
      .el-radio-button {
        margin-right: 110px;
        margin-bottom: 25px;
        text-align: center;
        .el-radio-button__inner {
          border-radius: 20px;
          border-left: 1px solid #b3b3b3;
          color: #333;
          padding: 10px 0;
          width: 100px;
        }
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #ffb03e;
        border-color: #ffb03e;
        box-shadow: -1px 0 0 0 #ffb03e;
        color: #fff;
      }
    }
    .product-name {
      width: 240px;
    }
    .product-price,
    .product-pics {
      width: 100px;
    }
  }
}
.el-message--error {
  top: 45% !important;
}
</style>
